<app-loader></app-loader>
<div class="container-fluid m-0 p-0 h-100">
  <!--Pre-logIn-->
  <div
    class="row m-0"
    [ngClass]="{
      layout: headerStyle !== 'auth' || isLandingPage,
      'layout-auth': headerStyle === 'auth' && !isLandingPage
    }"
  >
    <!-- If not auth module -->
    <app-header
      class="layout-header"
      *ngIf="headerStyle !== 'auth' && !isLandingPage"
    ></app-header>
    <!-- If auth module -->
    <app-sidebar
      class="auth-sidebar"
      *ngIf="headerStyle === 'auth' && !isLandingPage"
    ></app-sidebar>

    <!-- Content -->
    <section
      [ngClass]="{
        'auth-content': headerStyle === 'auth' && !isLandingPage,
        'layout-content': headerStyle !== 'auth' || isLandingPage
      }"
    >
      <router-outlet></router-outlet>
    </section>

    <!-- If not auth module -->
    <app-post-footer
      class="layout-footer"
      *ngIf="headerStyle !== 'auth' && !isLandingPage"
    ></app-post-footer>
    <!-- If auth module -->
    <app-footer
      class="auth-footer"
      *ngIf="headerStyle === 'auth' && !isLandingPage"
    ></app-footer>
  </div>
</div>

<app-help-bot></app-help-bot>
